/** Applica allo store un input interpretato (coordinate, link Maps, ricerche). */

import { searchPlaces } from '../lib/geocode';
import { resolveShortLink, ShortLinkError, type ParsedMapsInput } from '../lib/gmaps';
import { useAppStore, type Which } from './store';

/**
 * Applica l'input al punto `which`. Ritorna true se un punto è stato
 * impostato, false se l'input è una ricerca testuale da gestire col dropdown.
 * Può lanciare ShortLinkError (o errori di rete) con messaggi per l'utente.
 */
export async function applyParsedInput(which: Which, parsed: ParsedMapsInput): Promise<boolean> {
  const s = useAppStore.getState();
  switch (parsed.kind) {
    case 'point':
      s.setPoint(which, parsed.point);
      return true;

    case 'pair':
      s.setBoth(parsed.a, parsed.b);
      s.setHint('Partenza e arrivo impostati dal link di Google Maps.');
      return true;

    case 'shortlink': {
      const resolved = await resolveShortLink(parsed.url);
      return applyParsedInput(which, resolved);
    }

    case 'dirQueries': {
      const [fromRes, toRes] = await Promise.all([
        searchPlaces(parsed.from, { limit: 1 }),
        searchPlaces(parsed.to, { limit: 1 }),
      ]);
      if (fromRes[0] && toRes[0]) {
        s.setBoth(fromRes[0].ll, toRes[0].ll, fromRes[0].label, toRes[0].label);
        s.setHint('Partenza e arrivo impostati dal link di Google Maps.');
        return true;
      }
      throw new ShortLinkError(
        `Non ho trovato "${parsed.from}" o "${parsed.to}" su OpenStreetMap: cerca i luoghi manualmente.`,
      );
    }

    case 'query':
      return false;
  }
}
